<sb-dropdown-field
  [label]="name"
  [control]="control"
  [filterable]="true"
  [placeholder]="'Select ' + name + '...'"
  [options]="options"
>
</sb-dropdown-field>
